import { registerIcons } from "@fluentui/react";
let hasInitialized = false;
export function initializeWidgetIcons() {
    if (!hasInitialized) {
        hasInitialized = true;
        const subset = {
            style: {
                MozOsxFontSmoothing: "grayscale",
                WebkitFontSmoothing: "antialiased",
                fontStyle: "normal",
                fontWeight: "normal",
                speak: "none"
            },
            fontFace: {
                fontFamily: `"WidgetIcons"`,
                src: `url("./icons/widgets-icons.woff") format("woff")`
            },
            icons: {
                "SegoeFluentAdd": "\uE710",
                "SegoeFluentBadgeNotification": "\uE3BC",
                "SegoeFluentChevronDown": "\uE70D",
                "SegoeFluentChevronRight": "\uE76C",
                "SegoeFluentChevronUp": "\uE70E",
                "SegoeFluentChromeClose": "\uE8BB",
                "SegoeFluentEdit": "\uE70F",
                "SegoeFluentInfo": "\uE946",
                "SegoeFluentLocaleLanguage": "\uF2B7",
                "SegoeFluentMegaphone": "\uE789",
                "SegoeFluentMobNotificationBell": "\uF2A3",
                "SegoeFluentNews": "\uE900",
                "SegoeFluentOpenInNewWindow": "\uE8A7",
                "SegoeFluentPlugConnected": "\uF302",
                "SegoeFluentWidgetBoard": "\uE66F",
                "SegoeFluentWindows": "\uE782",
                "SegoeFluentMicrosoftLogoRed": "\uEB71",
                "SegoeFluentMicrosoftLogoGreen": "\uEB72",
                "SegoeFluentMicrosoftLogoBlue": "\uEB73",
                "SegoeFluentMicrosoftLogoYello": "\uEB74",
            }
        };
        registerIcons(subset);
    }
    ;
}
